import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import AvthorDetail from '@/components/screens/avthor-detail/AvthorDetail';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';
import { IAvthorDetail } from '@/interfaces/avthorDetail.interface';
import { ISimilarAuthors } from '@/interfaces/similarAuthors';

interface IAvthorDetailPageDynamicProps {
  books: IAvthorDetail;
  similarAuthors: ISimilarAuthors;
}

const AvthorDetailPageDynamic: NextPage<IAvthorDetailPageDynamicProps> = ({ books, similarAuthors }) => {
  return <AvthorDetail books={books} sortingName="сначала новые" similarAuthors={similarAuthors} />;
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const [booksRes, similarAuthorsRes] = await Promise.all([fetch(`${API_URL}satellite/author/info/${alias}?page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=created_at&sort_reversed=true`), fetch(`${API_URL}satellite/similar/author/${alias}`)]);

  // Check fetch error
  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  const [books, similarAuthors] = await Promise.all([booksRes.json(), similarAuthorsRes.json()]);

  if (!books.books?.total_count) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      books,
      similarAuthors,
    },
  };
};

export default AvthorDetailPageDynamic;
